import {Injectable} from '@angular/core';
import {ExternalTooltip} from '../data/externalTooltip';
import {Tooltip} from '../data/tooltip';
import {PopupFlagEditorComponent} from '../../flag/components/popup-flag-editor/popup-flag-editor.component';
import {FlagEditorTooltip} from '../../flag/data/flagEditorTooltip';
import {CustomerTooltip} from '../../customers/data/customer.tooltip';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {

  customerTooltips: CustomerTooltip[] = [];
  externalTooltips: ExternalTooltip[] = [];
  flagEditors: FlagEditorTooltip[] = [];

  constructor() {

    setInterval(() => {
      for (const tooltip of this.customerTooltips) {
        this.tick(tooltip);
      }
      for (const tooltip of this.externalTooltips) {
        this.tick(tooltip);
      }
      for (const editor of this.flagEditors) {
        this.tick(editor);
      }
    }, 200);
  }

  tick(tooltip: Tooltip) {
    if (tooltip) {
      if (tooltip.leftArea) {
        tooltip.life -= 0.2;
        if (tooltip.life < 0) {
          tooltip.life = 0;
        }
      }
    }
  }
}
